@if (hierarchy() === iconHierarchy.primary) {
<div
  class="p-1.5 bg-primary dark:bg-primary-faint w-fit flex items-center rounded-2xl">
  <i [class]="primaryIconClasses()"></i>
</div>
} @else if (hierarchy() === iconHierarchy.inverted) {
<div
  class="p-1.5 bg-primary-faint dark:bg-primary w-fit flex items-center rounded-2xl">
  <i [class]="invertedIconClasses()"></i>
</div>
} @else {
<i [class]="basicIconClasses()"></i>
}
